<template>
  <div v-if="isDesktop" class="card-review-container" :class="{ 'relevant-review-v2': isRelevantReview }">
    <div
      class="card-review-body"
      :class="{
        'relevant-review-v2': isRelevantReview,
        'expert-review':
          (reviewData.user && reviewData.user.is_expert_reviewer) ||
          (reviewData.owner && reviewData.owner.is_expert_reviewer),
      }"
    >
      <div class="card-review-content" :class="{ 'product-detail-review': isProductDetailPage }">
        <div v-if="!isRelevantReview" class="review-body-left-container">
          <div class="card-userinfo--uniform">
            <GImageUser
              :username="reviewData.user.user_name || null"
              :src="reviewData.user.image"
              class="img-user"
              class-name="avatar"
              :alt="reviewData.user.user_name || 'icon-default-avatar'"
              :user-level="reviewData.user.user_level"
              :is-expert-review="isExpertReview"
              :user="reviewData.user"
            />
            <div class="userinfo">
              <a
                :href="`${$store.state.SOCO_WEB_URL}/${reviewData.user.user_name}/timeline`"
                target="_blank"
                rel="noopener"
              >
                <h4 v-if="reviewData.user && reviewData.user.name" class="username">
                  {{ reviewData.user.name }}
                  <span v-if="isExpertReview && reviewData.user && reviewData.user.expert_role" class="expert-role">{{
                    reviewData.user.expert_role | expertRoleLabel
                  }}</span>
                </h4>
                <h4 v-else-if="reviewData.user && reviewData.user.user_name" class="username">
                  {{ reviewData.user.user_name }}
                </h4>
              </a>
              <div class="userinfo-detail">
                <SkinTypesV2
                  v-if="!showHairTypes"
                  :skin-types="reviewData.user.skin_types"
                  :hair-types="reviewData.user.hair_types"
                  :only-skin-types="false"
                />
                <HairTypesV2
                  v-else
                  :skin-types="reviewData.user.skin_types"
                  :hair-types="reviewData.user.hair_types"
                  :only-hair-types="false"
                />
              </div>
            </div>
          </div>
          <router-link v-if="!isProductDetailPage" :to="urlDetailProduct" class="product-card-container">
            <div class="product-card-body">
              <div class="product-card-left">
                <img
                  v-if="coverImage(reviewData.product.images)"
                  :src="coverImage(reviewData.product.images).url"
                  :alt="reviewData.product.name"
                />
              </div>
              <div v-if="reviewData.product" class="product-card-right">
                <h3 v-if="reviewData.product.brand" class="title">{{ reviewData.product.brand.name }}</h3>
                <p class="subtitle">{{ reviewData.product.name }}</p>
                <GRatingInline
                  v-if="averageRatingUser"
                  class-modifier="average-rating--uniform"
                  :average-rating="averageRatingUser.toFixed(1)"
                  :star-fill-number="starFillNumber"
                />
              </div>
            </div>
          </router-link>
          <div class="rate-detail">
            <div v-if="reviewData.star_packaging" class="rate-content">
              <span>{{ `${reviewData.star_packaging.toFixed()}/5` }}</span>
              <p>Packaging</p>
            </div>
            <div v-if="reviewData.star_eficiency" class="rate-content">
              <span>{{ `${reviewData.star_eficiency.toFixed()}/5` }}</span>
              <p>Efficiency</p>
            </div>
            <div v-if="reviewData.star_durability" class="rate-content">
              <span>{{ `${reviewData.star_durability.toFixed()}/5` }}</span>
              <p>Durability</p>
            </div>
            <div v-if="reviewData.star_pigmentation" class="rate-content">
              <span>{{ `${reviewData.star_pigmentation.toFixed()}/5` }}</span>
              <p>Pigmentation</p>
            </div>
            <div v-if="reviewData.star_long_wear" class="rate-content">
              <span>{{ `${reviewData.star_long_wear.toFixed()}/5` }}</span>
              <p>Long Wear</p>
            </div>
            <div v-if="reviewData.star_effectiveness" class="rate-content">
              <span>{{ `${reviewData.star_effectiveness.toFixed()}/5` }}</span>
              <p>Effectiveness</p>
            </div>
            <div v-if="reviewData.star_texture" class="rate-content">
              <span>{{ `${reviewData.star_texture.toFixed()}/5` }}</span>
              <p>Texture</p>
            </div>
            <div v-if="reviewData.star_value_for_money" class="rate-content">
              <span>{{ `${reviewData.star_value_for_money.toFixed()}/5` }}</span>
              <p>Value for Money</p>
            </div>
          </div>
          <div v-if="!isRelevantReview" class="content-footer-left">
            <div class="rating-footer">
              <div class="title">Recommend</div>
              <div class="subtitle">{{ recommendText }}</div>
            </div>
            <div class="rating-footer">
              <div class="title">Repurchase</div>
              <div class="subtitle">{{ repurchasedText }}</div>
            </div>
            <div class="rating-footer">
              <div class="title">Usage Period</div>
              <div class="subtitle">{{ reviewData.duration_of_used }}</div>
            </div>
          </div>
        </div>
        <div class="review-body-right-container">
          <div v-if="!isRelevantReview" class="review-time">
            <p>{{ reviewData.created_at | relativeTimeEn }}</p>
          </div>
          <div class="rating-container">
            <GRatingInline
              v-if="averageRatingUser"
              class-modifier="average-rating--uniform"
              :average-rating="averageRatingUser.toFixed(1)"
              :star-fill-number="starFillNumber"
            />
            <a
              v-if="isRelevantReview"
              class="review-time"
              :href="`${$store.state.SOCO_WEB_URL}/${reviewData.user.user_name}/timeline`"
              target="_blank"
              rel="noopener"
            >
              <h4 v-if="reviewData.user && reviewData.user.name" class="username">
                {{ reviewData.user.name }}
                <span v-if="isExpertReview && reviewData.user && reviewData.user.expert_role" class="expert-role">{{
                  reviewData.user.expert_role | expertRoleLabel
                }}</span>
              </h4>
              <h4 v-else-if="reviewData.user && reviewData.user.user_name" class="username">
                {{ reviewData.user.user_name }}
              </h4>
            </a>
            <div v-if="!isRelevantReview" class="label-button">
              <img
                v-if="reviewData.user.is_expert_reviewer"
                src="/assets/img/expert-review-label-v2.svg"
                alt=""
                height="30"
                width="144"
              />
              <img
                v-else-if="!reviewData.user.is_expert_reviewer && reviewData.is_verified_purchase"
                src="/assets/img/icon-shopper-label-v2.svg"
                alt=""
                height="30"
                width="144"
              />
            </div>
          </div>
          <div class="review-product-variant-container">
            <div
              v-if="hasProductVariant"
              class="label-product-variant"
              v-html="
                showProductDetail(
                  reviewData.product.combinations && reviewData.product.combinations.length
                    ? reviewData.product.combinations
                    : reviewData.product.combination
                )
              "
            ></div>
          </div>
          <div class="review-content">
            <template v-if="String(reviewData.details).length > 282">
              <template v-if="isRelevantReview">
                <p class="desc">
                  {{ String(reviewData.details).substr(0, 210) }}
                  <span>...</span>
                  <span class="read-more" @click.prevent="openSeeMorePopup"> (Read more)</span>
                </p>
              </template>
              <template v-else>
                <template v-if="isExpertReview && $route.name === 'ExpertPage'">
                  <div>
                    <p class="desc">
                      {{ reviewData.details }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div v-if="seeMoreDetailsOpen">
                    <p class="desc">
                      {{ reviewData.details }}
                      <span class="read-more" @click.prevent="toggleSeeMore">See less</span>
                    </p>
                  </div>
                  <div v-else>
                    <p class="desc">
                      {{ reviewData.details | trimRecentReviewContent }}
                      <span class="read-more" @click.prevent="toggleSeeMore">See more</span>
                    </p>
                  </div>
                </template>
              </template>
            </template>
            <template v-else>
              <p class="desc">{{ reviewData.details }}</p>
            </template>
            <ListUserPhoto
              v-if="$SO.size(reviewData.images)"
              :key="`list-user-photo-${reviewData['_id']}`"
              :average-rating="reviewData.average_rating ? reviewData.average_rating : 0"
              :details="reviewData.details ? reviewData.details : ''"
              :images="reviewData.images"
              :created_at="reviewData.created_at"
              :user="reviewData.user"
              :max_photo="isRelevantReview ? 2 : 5"
              :display-remaining-photo="isRelevantReview"
            />
          </div>
        </div>
      </div>
      <div class="card-footer-content" :class="{ 'product-detail-card-action-review': isProductDetailPage }">
        <div class="content-footer-right" :class="{ 'relevant-grid': isRelevantReview }">
          <div class="footer-action-container">
            <div class="left-content">
              <div v-if="!isLogin" class="grouped-icon" @click="loginOtf">
                <i class="journal-icon--uniform helpful" :class="{ active: reviewData.has_liked }"></i> Helpful
                {{ likers.total_likes ? `(${likers.total_likes})` : '' }}
              </div>
              <div v-else class="grouped-icon" @click="like(reviewData.newsfeed_id)">
                <i class="journal-icon--uniform helpful" :class="{ active: reviewData.has_liked }"></i> Helpful
                {{ likers.total_likes ? `(${likers.total_likes})` : '' }}
              </div>
              <!-- <div
                v-if="showBookmark && isLogin && isDesktop"
                class="grouped-icon"
                @click="bookmark(reviewData.newsfeed_id)"
              >
                <i class="journal-icon--uniform bookmark" :class="{ active: reviewData.has_bookmarked }"></i> Bookmark
              </div> -->
              <div class="grouped-icon" @click="modalShare()"><i class="journal-icon--uniform share"></i> Share</div>
            </div>
            <div class="right-content">
              <span v-if="ownerOfReview && reviewData.edited_at" class="text-edit">
                (Edited at {{ reviewData.updated_at | dateMonthYear }})
              </span>
              <span
                v-else-if="ownerOfReview && !reviewData.is_editable && !reviewData.hasOwnProperty('is_editable')"
                class="text-edit"
              >
                (Edit)
              </span>
              <div v-if="ownerOfReview && isLogin" class="grouped-icon">
                <a href="" class="journal-icon--uniform more" @click.prevent="toggleDropdown"></a>
                <div v-if="isOpenDropdown" class="action-top-card-dropdown--uniform active">
                  <a v-if="ownerOfReview && isLogin" href="" @click.prevent="editReview">
                    <span class="journal-icon--uniform edit">Edit Review</span>
                  </a>
                  <a v-if="ownerOfReview && isLogin" href="" @click.prevent="requestToDelete(reviewData.newsfeed_id)">
                    <span class="journal-icon--uniform request-delete">Request to Delete</span>
                  </a>
                </div>
              </div>
              <div v-else class="grouped-icon">
                <i v-if="reviewData.has_reported && isLogin" class="journal-icon--uniform report"></i>
                <i
                  v-else-if="!reviewData.has_reported && isLogin"
                  class="journal-icon--uniform report"
                  @click="openModalReport()"
                ></i>
                <i v-else class="grouped-icon" @click="loginOtf"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="card-review-container-mobile">
    <div
      class="card-review-body-mobile"
      :class="{
        'expert-review':
          (reviewData.user && reviewData.user.is_expert_reviewer) ||
          (reviewData.owner && reviewData.owner.is_expert_reviewer),
      }"
    >
      <div class="card-userinfo--uniform">
        <GImageUser
          :username="reviewData.user.user_name || null"
          :src="reviewData.user.image"
          class="img-user"
          class-name="avatar"
          :alt="reviewData.user.user_name || 'icon-default-avatar'"
          :user-level="reviewData.user.user_level"
          :is-expert-review="isExpertReview"
          :user="reviewData.user"
        />

        <div class="userinfo">
          <a
            :href="`${$store.state.SOCO_WEB_URL}/${reviewData.user.user_name}/timeline`"
            target="_blank"
            rel="noopener"
          >
            <h4 v-if="reviewData.user && reviewData.user.name" class="username">
              {{ reviewData.user.name }}
              <span v-if="isExpertReview && reviewData.user && reviewData.user.expert_role" class="expert-role">{{
                reviewData.user.expert_role | expertRoleLabel
              }}</span>
            </h4>
            <h4 v-else-if="reviewData.user && reviewData.user.user_name" class="username">
              {{ reviewData.user.user_name }}
            </h4>
          </a>
          <div class="userinfo-detail">
            <SkinTypesV2
              v-if="!showHairTypes"
              :skin-types="reviewData.user.skin_types"
              :hair-types="reviewData.user.hair_types"
              :only-skin-types="false"
            />
            <HairTypesV2
              v-else
              :skin-types="reviewData.user.skin_types"
              :hair-types="reviewData.user.hair_types"
              :only-hair-types="false"
            />
          </div>
        </div>
      </div>
      <div class="review-time-mobile">
        <p>{{ reviewData.created_at | relativeTimeEn }}</p>
      </div>
      <div class="card-review-body-top-content">
        <GRatingInline
          v-if="averageRatingUser"
          class-modifier="average-rating--uniform"
          :average-rating="averageRatingUser.toFixed(1)"
          :star-fill-number="starFillNumber"
        />
        <div class="label-container">
          <img
            v-if="reviewData.user.is_expert_reviewer"
            src="/assets/img/expert-review-label-v2.svg"
            alt=""
            height="100%"
            width="100%"
          />
          <img
            v-else-if="!reviewData.user.is_expert_reviewer && reviewData.is_verified_purchase"
            src="/assets/img/icon-shopper-label-v2.svg"
            alt=""
            height="100%"
            width="100%"
          />
        </div>
      </div>
      <router-link v-if="$route.name !== 'productDetail'" :to="urlDetailProduct" class="product-card-container">
        <div class="product-card-body">
          <div class="product-card-left">
            <img
              v-if="coverImage(reviewData.product.images)"
              :src="coverImage(reviewData.product.images).url"
              :alt="reviewData.product.name"
            />
          </div>
          <div v-if="reviewData.product" class="product-card-right">
            <h3 v-if="reviewData.product.brand" class="title">{{ reviewData.product.brand.name }}</h3>
            <p class="subtitle">{{ reviewData.product.name }}</p>
            <GRatingInline
              v-if="averageRatingUser"
              class-modifier="average-rating--uniform"
              :average-rating="averageRatingUser.toFixed(1)"
              :star-fill-number="starFillNumber"
            />
          </div>
        </div>
      </router-link>
      <div class="review-product-variant-container">
        <div
          v-if="reviewData.product.variant"
          class="label-product-variant"
          @click="filterByCombination(reviewData.product.combination.id)"
        >
          {{ formatVariant(reviewData.product.variant) }}
        </div>
        <div
          v-if="reviewData.product.combination"
          class="label-product-variant"
          v-html="showProductDetail(reviewData.product.combination)"
        ></div>
      </div>
      <div class="review-content">
        <template v-if="String(reviewData.details).length > 282">
          <template v-if="isRelevantReview">
            <p class="desc">
              {{ String(reviewData.details).substr(0, 210) }}
              <span>...</span>
              <span class="read-more" @click.prevent="openSeeMorePopup"> (Read more)</span>
            </p>
          </template>
          <template v-else>
            <template v-if="isExpertReview && $route.name === 'ExpertPage'">
              <div>
                <p class="desc">
                  {{ reviewData.details }}
                </p>
              </div>
            </template>
            <template v-else>
              <div v-if="seeMoreDetailsOpen">
                <p class="desc">
                  {{ reviewData.details }}
                  <span class="read-more see-less" @click.prevent="toggleSeeMore">See less</span>
                </p>
              </div>
              <div v-else>
                <p class="desc">
                  {{ reviewData.details | trimRecentReviewContent }}
                  <span class="read-more" @click.prevent="toggleSeeMore">See more</span>
                </p>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <p class="desc">{{ reviewData.details }}</p>
        </template>
        <ListUserPhoto
          v-if="$SO.size(reviewData.images)"
          :key="`list-user-photo-${reviewData['_id']}`"
          :average-rating="reviewData.average_rating ? reviewData.average_rating : 0"
          :details="reviewData.details ? reviewData.details : ''"
          :images="reviewData.images"
          :created_at="reviewData.created_at"
          :user="reviewData.user"
          :max_photo="isRelevantReview ? 4 : 5"
          :display-remaining-photo="isRelevantReview"
        />
      </div>
      <div class="content-footer-right">
        <div class="footer-action-container">
          <div class="left-content">
            <div v-if="!isLogin" class="grouped-icon" @click="loginOtf">
              <i class="journal-icon--uniform helpful" :class="{ active: reviewData.has_liked }"></i> Helpful
              {{ likers.total_likes ? `(${likers.total_likes})` : '' }}
            </div>
            <div v-else class="grouped-icon" @click="like(reviewData.newsfeed_id)">
              <i class="journal-icon--uniform helpful" :class="{ active: reviewData.has_liked }"></i> Helpful
              {{ likers.total_likes ? `(${likers.total_likes})` : '' }}
            </div>
            <div
              v-if="showBookmark && isLogin && isDesktop"
              class="grouped-icon"
              @click="bookmark(reviewData.newsfeed_id)"
            >
              <i class="journal-icon--uniform bookmark" :class="{ active: reviewData.has_bookmarked }"></i> Bookmark
            </div>
            <div class="grouped-icon" @click="modalShare()"><i class="journal-icon--uniform share"></i> Share</div>
          </div>
          <div class="right-content">
            <span v-if="ownerOfReview && reviewData.edited_at" class="text-edit">
              (Edited at {{ reviewData.updated_at | dateMonthYear }})
            </span>
            <span
              v-else-if="ownerOfReview && !reviewData.is_editable && !reviewData.hasOwnProperty('is_editable')"
              class="text-edit"
            >
              (Edit)
            </span>
            <div v-if="ownerOfReview && isLogin" class="grouped-icon">
              <a href="" class="journal-icon--uniform more" @click.prevent="toggleDropdown"></a>
              <div v-if="isOpenDropdown" class="action-top-card-dropdown--uniform active">
                <a v-if="ownerOfReview && reviewData.is_editable" href="" @click.prevent="editReview">
                  <span class="journal-icon--uniform edit">Edit Review</span>
                </a>
                <a v-if="ownerOfReview && isLogin" href="" @click.prevent="requestToDelete(reviewData.newsfeed_id)">
                  <span class="journal-icon--uniform request-delete">Request to Delete</span>
                </a>
              </div>
            </div>
            <div v-else class="grouped-icon">
              <i v-if="reviewData.has_reported && isLogin" class="journal-icon--uniform report"></i>
              <i
                v-else-if="!reviewData.has_reported && isLogin"
                class="journal-icon--uniform report"
                @click="openModalReport()"
              ></i>
              <i v-else class="grouped-icon" @click="loginOtf"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SkinTypes from './skin-types/skin-types';
import SkinTypesV2 from './skin-types/skin-types-v2';
// import HairTypes from './hair-types/hair-types';
import HairTypesV2 from './hair-types/hair-types-v2';
import ListUserPhoto from './list-user-photo';
import Auth from '@/shared/auth';

export default {
  name: 'card-review-detail-v2',
  components: {
    HairTypesV2,
    SkinTypesV2,
    ListUserPhoto,
  },
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
    showProduct: {
      type: Boolean,
      required: false,
      default: true,
    },
    showBookmark: {
      type: Boolean,
      required: false,
      default: false,
    },
    on: {
      type: String,
      required: true,
    },
    isRelevantReview: {
      type: Boolean,
      required: false,
      default: false,
    },
    index: {
      type: Number,
      required: false,
      default: 1,
    },
    isExpertReview: {
      type: Boolean,
      default: false,
    },
    leftColumn: {
      type: Number,
      default: 5,
    },
    rightColumn: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      likers: {
        likes: [],
        total_likes: 0,
      },
      isOpenDropdown: false,
      isOpenShareDropdown: false,
      seeMoreDetailsOpen: false,
      isLoadingFinishListUserPhoto: false,
      listUserPhoto: '',
      collapsed: false,
      isLoadingLikeReview: false,
    };
  },
  computed: {
    hasProductVariant() {
      const combos = this.reviewData.product.combinations;
      const combo = combos && combos.length ? combos : this.reviewData.product.combination;
      const variant = this.showProductDetail(combo);
      return variant && variant.trim().length > 0;
    },
    isIndonesianSource() {
      return !/vn/gi.test(this.reviewData.source);
    },
    showHairTypes() {
      const product = this.reviewData.product || {};
      const categories = product.categories || [];
      const category = product.parent_category || product.default_category || { name: '' };

      const keywords = ['hair', 'shampoo'];

      // directly check instead of building names[]
      let is_hair_care = false;

      // Check main category
      if (category.name) {
        const lower = category.name.toLowerCase();
        if (keywords.some((kw) => lower.includes(kw))) {
          is_hair_care = true;
        }
      }

      // If not yet found, check additional categories because there is product that have parent_category and default category null
      if (!is_hair_care) {
        for (let i = 0; i < categories.length; i++) {
          const c = categories[i];
          if (!c || !c.name) {
            continue;
          }
          const lower = c.name.toLowerCase();
          if (keywords.some((kw) => lower.includes(kw))) {
            is_hair_care = true;
            break;
          }
        }
      }

      return is_hair_care;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    averageRatingUser() {
      let averageRatingUser = 0;
      let sumRatingUser = 0;
      let sumGiveRating = 0;
      this.$SO.each(this.reviewData, (prop, val) => {
        if (/star_/.test(prop) && val) {
          sumRatingUser += val;
          sumGiveRating++;
        }
      });
      averageRatingUser = sumRatingUser / sumGiveRating;
      return averageRatingUser;
    },
    tooltipOptions() {
      const triggerValue = this.screen.isDesktop ? 'hover' : 'click';
      const placementValue = this.screen.isDesktop ? 'bottom-start' : 'bottom-start';
      return {
        content:
          'Review terpercaya dari user yang membeli produk kecantikan di Sociolla atau mendapatkan produk kecantikan dari program sampling kami',
        trigger: triggerValue,
        placement: placementValue,
      };
    },
    imgSrc() {
      return this.$SO.size(this.reviewData.user) ? this.reviewData.user.image : null;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    ownerOfReview() {
      return this.reviewData.user.id === (this.$store.state.userProfile && this.$store.state.userProfile._id);
    },
    repurchasedText() {
      if (this.reviewData.is_repurchase == 'yes') {
        return 'Yes';
      } else if (this.reviewData.is_repurchase == 'no') {
        return 'No';
      } else {
        return 'Maybe';
      }
    },
    recommendText() {
      if (this.reviewData.is_recommended == 'yes') {
        return 'Yes';
      } else {
        return 'No';
      }
    },
    screen() {
      return this.$store.state.screen;
    },
    showProductAttribute() {
      if (this.reviewData.product && this.reviewData.product.variant) {
        return !/non specify/.test(this.reviewData.product.variant.toLowerCase());
      } else {
        return false;
      }
    },
    starFillNumber() {
      const starFillNumber = this.$options.filters.rating(this.averageRatingUser) * 10;
      return starFillNumber ? starFillNumber : 0;
    },
    idUser() {
      return this.$store.state.userProfile._id;
    },
    rightColumnClass() {
      return !this.isRelevantReview
        ? `col-lg-${this.rightColumn} col-md-${this.rightColumn} ${
            this.isExpertReview ? 'expert-review-right-column' : 'review-right-column'
          }`
        : '';
    },
    urlDetailProduct() {
      let result = '';
      if (this.reviewData.product.default_category) {
        result = `/product/${this.$options.filters.slug(this.reviewData.product.default_category.name)}/${
          this.reviewData.product.id
        }-${this.$options.filters.slug(this.reviewData.product.name)}`;
      } else {
        result = this.$options.filters.productUrlReview(this.reviewData.product);
      }
      return result;
    },
    isProductDetailPage() {
      return this.$route.name == 'productDetail';
    },
  },
  created() {
    this.likers = {
      likes: this.reviewData.likes ? [...this.reviewData.likes] : [],
      total_likes: this.reviewData.total_likes ? this.reviewData.total_likes : 0,
    };
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
  },
  methods: {
    filterByCombination(id) {
      if (id) {
        this.$emit('apply-filter', {
          combinations: [id],
          fetch: false,
        });
      }
    },
    formatVariant(variant) {
      if (variant && variant.match(/,/g) && variant.match(/,/g).length === 1) {
        return variant.replace(',', '');
      }
      return variant;
    },
    toggle() {
      this.collapsed = !this.collapsed;
    },
    documentClick(e) {
      const target = e.target;
      if (this.isOpenDropdown) {
        if (this.$SO(target).closest('.journal-icon--uniform').length < 1) {
          this.isOpenDropdown = false;
        }
      }
    },
    ageRange(birthdate) {
      const getAge = Math.floor((new Date() - new Date(birthdate).getTime()) / 3.15576e10);
      return this.$options.filters.rangeForAge(getAge);
    },
    showProductDetail(combination) {
      if (!combination) {
        return '';
      }
      const style = 'width:18px;height:18px;border-radius:50%;margin-right:5px;padding:0;';
      let combo;
      if (Array.isArray(combination)) {
        combo = combination.find((c) => c.is_default) || combination[0];
      } else {
        combo = combination;
      }
      const attrs = (combo && combo.attributes) || (combo && combo.attribute) || null;
      if (!attrs || Object.keys(attrs).length === 0) {
        return '';
      }

      let variant = '';
      let visibleIndex = 0;
      Object.keys(attrs)
        .sort()
        .forEach(function (attr) {
          const item = attrs[attr];
          if (!item || typeof item !== 'object') {
            return;
          }
          const value = item.value || '';
          const name = item.name || '';

          if (visibleIndex > 0) {
            variant += ' - ';
          }

          if (attr === 'shade' && value) {
            let img = '';
            if (this.isImage(value)) {
              img =
                '<img src="' +
                value +
                '" style="' +
                style +
                '" onerror="this.src=\'/assets/img/dummy-combination.png\'" />';
            } else {
              img = '<button style="' + style + 'border:none;background:' + value + '"></button>';
            }
            variant += img + ' ' + name;
            visibleIndex++;
          } else if (attr !== 'non_specify' && name) {
            variant += name;
            visibleIndex++;
          }
        }, this);
      return variant;
    },
    isImage(value) {
      if (value && value.search('#') !== -1 && value.length <= 7) {
        return false;
      } else {
        return true;
      }
    },
    bookmarkAction(reviewId, value) {
      if (this.on === 'expert-page') {
        this.$emit('set-bookmark', {
          value,
          reviewId,
        });
      } else {
        this.$store.commit('review/SET_HAS_BOOKMARKED', {
          on: this.on,
          value,
          reviewId,
        });
      }
    },
    bookmark(id) {
      this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);

      this.$MS_SOCO_PUBLIC_API_URL
        .post(`/newsfeed/${id}/bookmarks`)
        .then((response) => {
          if (response.status !== 200) {
            this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);
          }
        })
        .catch(() => {
          this.bookmarkAction(this.reviewData._id, !this.reviewData.has_bookmarked);
        });
    },
    editReview() {
      const review = JSON.parse(JSON.stringify(this.reviewData));
      this.$store.dispatch('setDataModalEditReview', review);
      this.$store.commit('toggleModalGlobalState', { modalName: 'editReview' });
    },
    likeAction(reviewId, value) {
      if (this.on === 'expert-page' || (this.on === 'product' && this.isRelevantReview)) {
        this.$emit('set-like', {
          value,
          reviewId,
        });
      } else {
        this.$store.commit('review/SET_HAS_LIKED', {
          on: this.on,
          value,
          reviewId,
        });
      }
    },
    like(id) {
      if (!this.isLoadingLikeReview) {
        this.isLoadingLikeReview = true;
        this.$MS_SOCO_PUBLIC_API_URL
          .post(`/newsfeed/${id}/likes`)
          .then((response) => {
            if (response.status == 200 && response.data.success) {
              this.likeAction(this.reviewData._id, response.data.data.has_liked);

              if (response.data.data.has_liked) {
                this.likers.likes.unshift({
                  user: {
                    user_name: this.$store.state.auth.username,
                    image: this.$store.state.auth.userimage,
                  },
                });
                this.likers.total_likes++;
              } else {
                if (this.likers.likes.findIndex((user) => user.user_name === this.$store.state.auth.username)) {
                  this.likers.likes.splice(
                    this.likers.likes.findIndex((like) => like.user.user_name === this.$store.state.auth.username),
                    1
                  );
                }
                this.likers.total_likes--;
              }
            }
          })
          .catch(() => {
            this.$toasted.global.error('Silahkan coba beberapa saat lagi');
          })
          .finally(() => (this.isLoadingLikeReview = false));
      }
    },
    loginOtf() {
      Auth.CentralAuth.login();
    },
    openModalReport() {
      this.isOpenDropdown = false;
      this.$store.commit('setOpenModal', { stateName: 'report', newVal: true });
      this.$store.commit('setNewsfeedIdOfModalReport', this.reviewData.newsfeed_id);
    },
    requestToDelete(id) {
      this.$MS_SOCO_PUBLIC_API_URL
        .delete(`/newsfeed/${id}`)
        .then((res) => {
          if (res.data.success) {
            this.$toasted.global.show('Request untuk menghapus telah dikirim');
          } else {
            this.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
          }

          this.isOpenDropdown = false;
        })
        .catch(() => {
          this.isOpenDropdown = false;
          this.$toasted.global.error('Silakan coba lagi dalam beberapa saat');
        });
    },
    toggleDropdown() {
      this.isOpenDropdown = !this.isOpenDropdown;
    },
    toggleSeeMore() {
      this.seeMoreDetailsOpen = !this.seeMoreDetailsOpen;
    },
    openSeeMorePopup() {
      this.$store.commit('review/SET_SEE_MOTE_RELEVANT_REVIEWS', {
        content: this.reviewData.details,
        isOpen: true,
        index: this.index,
      });
    },
    toggleShare(newVal) {
      if (newVal) {
        this.isOpenShareDropdown = !newVal;
      } else {
        this.isOpenShareDropdown = !this.isOpenShareDropdown;
      }
    },
    modalShare() {
      const data = { ...this.reviewData.product };
      data['is_modal_review'] = true;
      data['average_rating'] = this.reviewData.average_rating || 0;
      data['total_reviews'] = this.reviewData.product.counter_review_user || 0;
      const images = this.reviewData.product.images || [];
      const is_cover = this.coverImage(images);
      data['image_cover'] = is_cover ? is_cover.url || '' : images.length > 0 ? images[0].url : '';
      data['from_page'] = 'pdp';
      this.$store.commit('setProductData', data);
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'tellFriends',
      });
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.screen.isDesktop ? 'w=80' : 'w=90',
        image: src,
      });
    },
    ownerImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=30',
        image: src,
      });
    },
    coverImage(images = []) {
      return images.find((image) => image.is_cover);
    },
    comparingDate(date1, date2) {
      const created = new Date(date1);
      const updated = new Date(date2);
      if (updated > created) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'card-review-detail-v2';
.mb-12 {
  margin-bottom: 12px !important;
}

.list-user-photo /deep/ {
  white-space: nowrap;
  overflow-x: auto;
  margin: 12px 0 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  .text-see-all {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 22;
    background-color: rgba(#f384a7, 0.8);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 12px/15px 'Lato-Bold', sans-serif;
    letter-spacing: 0;
    z-index: 4;
  }
}

.list-user-photo__img /deep/ {
  border-radius: 4px;
  height: 80px !important;
  width: 80px !important;
  object-fit: cover;
  border-radius: 4px !important;
}

.list-user-photo__item /deep/ {
  display: inline-block;
  margin-right: 8px;
  position: relative;
  height: 80px !important;
  width: 80px !important;
  :last-child {
    margin-right: 0;
  }
  img {
    height: 80px !important;
    width: 80px !important;
  }
}

.list-user-photo__see-all /deep/ {
  width: 80px;
  height: 80px;
  color: #ffffff;
}

.expert-review {
  background-color: #fff9fb;
  .product-card-container {
    border: 1px solid #fcddec;
  }
}

.average-rating--uniform /deep/ {
  margin-top: 0px;
}

.card-review-container {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d8d8d8;
  background-color: white;
}

.review-time {
  display: flex;
  justify-content: end;
  p {
    font: normal 12px 'lato-regular';
  }
}

.card-review-body {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-review-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
}

.review-body-left-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.card-userinfo--uniform /deep/ {
  gap: 20px;
  .img-user {
    .avatar-wrapper {
      position: relative;
      .avatar-user-level {
        position: absolute;
        bottom: 0;
        left: 20px;
      }
    }
  }
  .userinfo {
    flex: 1;
    max-width: 290px;
    @media (max-width: 768px) {
      max-width: 77%;
    }
  }
}

.user-section {
  display: flex;
  gap: 20px;
  .group-image-container {
    position: relative;
    display: flex;
  }
  .user-profile-container {
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-self: center;
    .user-name {
      align-self: center;
      h4 {
        font: 700 14px 'lato-bold';
      }
    }
    .beauty-profile {
      align-self: center;
      display: flex;
      flex-direction: row;
      gap: 5px;
      flex-wrap: wrap;
      .label {
        font: normal 12px 'lato-regular';
        padding: 5px 10px;
        border-radius: 20px;
        background-color: #dddddd;
      }
    }
  }
}

.review-body-right-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rating-container {
  align-self: center;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.label-button {
  align-self: center;
  img {
    align-self: center;
  }
}

.review-product-variant-container {
  display: flex;
  @media (max-width: 768px) {
    margin: 20px 0px;
  }
}

.label-product-variant {
  font-family: 'lato-regular';
  display: flex;
  justify-content: center;
  padding: 5px 10px;
  border: 1px solid pink;
  border-radius: 4px;
  align-self: center;
  gap: 10px;
  img {
    align-self: center;
    width: 19px;
    height: 19px;
    border-radius: 50%;
  }
  p {
    margin: 0px;
    align-self: center;
    font: 700 12px 'lato-bold';
  }
}

.review-content {
  p {
    font: normal 16px/22px 'lato-regular';
    word-break: break-word;
    .read-more {
      color: #eb395f;
    }
  }
}

.product-card-container {
  padding: 8.5px 16px;
  display: flex;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  justify-content: start;
  max-height: 90px;
  background-color: white;
}

.product-card-body {
  align-self: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}

.product-card-left {
  align-self: center;
  img {
    align-self: center;
    width: 60px;
    height: 60px;
  }
}

.product-card-right {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  .title {
    margin: 0px;
    font: 700 10px 'lato-bold';
    text-transform: uppercase;
  }
  .subtitle {
    margin: 0px;
    font: 400 12px 'lato-regular';
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 232px;
    @media (max-width: 425px) {
      max-width: 271px;
    }
    @media (max-width: 375px) {
      max-width: 232px;
    }
  }
}

.rate-detail {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  .rate-content {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-self: center;
    align-items: center;
    span {
      color: #f384a7;
      border-radius: 4px;
      padding: 3px 8px;
      background-color: #fcf1f1;
    }
    p {
      align-self: center;
      margin: 0px;
    }
    font: 400 14px 'lato-regular';
  }
}

.card-footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  margin-top: 20px;
}

.content-footer-left {
  padding-top: 12px;
  display: flex;
  flex-direction: row;
  gap: 30px;
  border-top: 1px dotted #d8d8d8;
}

.rating-footer {
  display: flex;
  flex-direction: column;
  gap: 3px;
  .title {
    font: 400 14px 'lato-regular';
  }
  .subtitle {
    font: bold 14px 'lato-bold';
    color: #f384a7;
  }
}

.content-footer-right {
  align-self: center;
  grid-column-start: 2;
  @media (max-width: 768px) {
    margin-top: 20px;
    align-self: stretch;
  }
  .footer-action-container {
    font-family: 'lato-regular';
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left-content {
      display: flex;
      flex-direction: row;
      gap: 10px;
      .grouped-icon {
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
    }
    .right-content {
      display: flex;
      align-self: center;
      gap: 10px;
      .text-edit {
        font: 13px/24px 'lato-regular', sans-serif;
        color: #8c8582;
        font-style: italic;
      }
      .grouped-icon {
        align-items: center;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
    }
  }
}

.card-review-container-mobile {
  display: flex;
  flex-direction: column;
  padding: 0px !important;
  position: relative;
  background-color: white;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 8px;
}

.card-review-body-mobile {
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
}

.review-time-mobile {
  position: absolute;
  right: 25px;
  p {
    font: normal 12px 'lato-regular';
    color: #999290;
    margin: 0px;
  }
}

.card-review-body-top-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  .label-container {
    width: 118px;
    height: 25px;
  }
}

.relevant-review-v2 {
  padding-bottom: 0px;
  border-bottom: 0px;
  .card-review-body {
    padding: 20px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
  }
  .card-review-content {
    display: flex;
    flex-direction: row-reverse;
  }
  .review-body-right-container {
    .username {
      font-size: 14px;
      align-self: center;
      font-family: 'lato-medium';
    }
  }
  .review-content {
    height: 17rem;
    display: flex;
    gap: 27px;
  }
}
.product-detail-review {
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 30px;
}

.product-detail-card-action-review {
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 30px;
  grid-column-start: 2;
}
.relevant-grid {
  grid-column-start: 1 !important;
  grid-column: 1/3;
}
</style>
